import { shareColumnsExtend, shareFormColumnsExtend } from './share';

const entityColumns = {
  id: {
    model_name: 'Product',
    column_type: 'id',
    label_key_path: 'product.id',
  },
  created_at: {
    model_name: 'Product',
    column_type: 'datetime',
    label_key_path: 'product.createdAt',
  },
  updated_at: {
    model_name: 'Product',
    column_type: 'datetime',
    label_key_path: 'product.updatedAt',
  },
  style_number: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.styleNumber',
  },
  semi_product: {
    model_name: 'Product',
    column_type: 'belongs_to',
    label_key_path: 'product.semiProduct',
    extra: {
      association_name: 'semi_product',
      model_name: 'Product',
      foreign_key: 'semi_style_number',
      display_column: 'name',
    },
  },
  semi_style_number: {
    model_name: 'Product',
    column_type: 'belongs_to',
    label_key_path: 'product.semiProduct',
    extra: {
      association_name: 'semi_product',
      model_name: 'Product',
      foreign_key: 'semi_style_number',
      display_column: 'name',
    },
  },
  number: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.number',
  },
  color_number: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.colorNumber',
  },
  product_category: {
    model_name: 'Product',
    column_type: 'belongs_to',
    label_key_path: 'product.productCategory',
    extra: {
      association_name: 'product_category',
      model_name: 'ProductCategory',
      foreign_key: 'product_category_id',
      display_column: 'name',
    },
  },
  product_category_id: {
    model_name: 'Product',
    column_type: 'belongs_to',
    label_key_path: 'product.productCategory',
    extra: {
      association_name: 'product_category',
      model_name: 'ProductCategory',
      foreign_key: 'product_category_id',
      display_column: 'name',
    },
  },
  creator: {
    model_name: 'Product',
    column_type: 'belongs_to',
    label_key_path: 'product.creator',
    extra: {
      association_name: 'creator',
      model_name: 'AdminUser',
      foreign_key: 'creator_id',
      display_column: 'name',
    },
  },
  creator_id: {
    model_name: 'Product',
    column_type: 'belongs_to',
    label_key_path: 'product.creator',
    extra: {
      association_name: 'creator',
      model_name: 'AdminUser',
      foreign_key: 'creator_id',
      display_column: 'name',
    },
  },
  supplier_name: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.supplierName',
  },
  vc_name: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.vcName',
  },
  sales_price: {
    model_name: 'Product',
    column_type: 'decimal',
    label_key_path: 'product.salesPrice',
  },
  cost_price: {
    model_name: 'Product',
    column_type: 'decimal',
    label_key_path: 'product.costPrice',
  },
  return_period: {
    model_name: 'Product',
    column_type: 'integer',
    label_key_path: 'product.returnPeriod',
  },
  release_at: {
    model_name: 'Product',
    column_type: 'datetime',
    label_key_path: 'product.releaseAt',
  },
  min_order_qty: {
    model_name: 'Product',
    column_type: 'integer',
    label_key_path: 'product.minOrderQty',
  },
  fabric_cutting_count: {
    model_name: 'Product',
    column_type: 'integer',
    label_key_path: 'product.fabricCuttingCount',
  },
  image: {
    model_name: 'Product',
    column_type: 'attached',
    extra: {
      size: 20,
    },
    label_key_path: 'product.image',
  },
  image_with_audio: {
    model_name: 'Product',
    prop: 'image_attachment',
    label_key_path: 'product.imageAttachment',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 20,
    },
  },
  size_option_values: {
    model_name: 'Product',
    column_type: 'has_many',
    label_key_path: 'product.sizeOptionValues',
    extra: {
      association_name: 'size_option_values',
      model_name: 'OptionValue',
      foreign_key: 'option_value_id',
      display_column: 'name',
    },
  },
  size_option_value_ids: {
    model_name: 'Product',
    column_type: 'has_many',
    label_key_path: 'product.sizeOptionValues',
    extra: {
      association_name: 'size_option_values',
      model_name: 'OptionValue',
      foreign_key: 'option_value_id',
      display_column: 'name',
    },
  },
  color_option_values: {
    model_name: 'Product',
    column_type: 'has_many',
    label_key_path: 'product.colorOptionValues',
    extra: {
      association_name: 'color_option_values',
      model_name: 'OptionValue',
      foreign_key: 'option_value_id',
      display_column: 'name',
    },
  },
  color_option_value_ids: {
    model_name: 'Product',
    column_type: 'has_many',
    label_key_path: 'product.colorOptionValues',
    extra: {
      association_name: 'color_option_values',
      model_name: 'OptionValue',
      foreign_key: 'option_value_id',
      display_column: 'name',
    },
  },
  variants: {
    model_name: 'Product',
    column_type: 'has_many',
    label_key_path: 'product.variants',
    extra: {
      association_name: 'variants',
      model_name: 'Variant',
      foreign_key: 'product_id',
      display_column: 'name',
    },
  },
  variant_ids: {
    model_name: 'Product',
    column_type: 'has_many',
    label_key_path: 'product.variants',
    extra: {
      association_name: 'variants',
      model_name: 'Variant',
      foreign_key: 'product_id',
      display_column: 'name',
    },
  },
  product_design: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.productDesign',
  },
  product_design_paper_pattern_files: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.productDesignPaperPatternFiles',
  },
  product_design_cost_detail_files: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.productDesignCostDetailFiles',
  },
  abilities: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.abilities',
  },
  color_option_value_list: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.colorOptionValueList',
  },
  product_design_cost_price: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.productDesignCostPrice',
  },
  product_design_settlement_cost: {
    model_name: 'Product',
    column_type: 'string',
    label_key_path: 'product.productDesignSettlementCost',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
